import { compose, find, prop, propEq } from 'ramda';
import { createSelector } from 'reselect';

import { codelists } from 'constants/codelists';
import { getCodelistByName } from 'utils/codelists';

import { NAME } from './constants';

export const getTemplateTable = (state) => {
	return state[NAME].list;
};
export const getTemplatesNumberAvailable = (state) => {
	return state[NAME].templatesNumberAvailable;
};
export const getShowAllTemplates = (state) => {
	return state[NAME].showAllTemplates;
};
export const getMaxTemplatesCount = createSelector(getCodelistByName(codelists.parameters), (parameters) => {
	return compose(prop('shortDescription'), find(propEq('CAMPAIGN_PATTERN_MAX', 'id')))(parameters);
});
